/**
 * Created by MTI on 15/08/2018.
 */

import {Component, HostListener, OnDestroy, OnInit, ViewChild} from '@angular/core';
import {MessageModel} from './message.model';
import {PerfectScrollbarComponent} from 'ngx-perfect-scrollbar';
import {EventBusService} from '../../util/event-bus.service';
import {ChatRequestResource} from './service/chat-request.resource';
import {UserAuth} from '../../auth/user-auth.model';
import {AuthServerProvider} from '../../auth/auth-jwt.service';
import {Title} from '@angular/platform-browser';
import {ChatGroupModel} from './chat-group.model';
import {ModalDirective, ToastService} from 'ng-uikit-pro-standard';

@Component({
  selector: 'app-chat-admin-component',
  templateUrl: 'chat-admin.component.html'
})
export class ChatAdminComponent implements OnInit, OnDestroy {
  public message: MessageModel[] = [];
  public chatList: ChatGroupModel[] = [];
  public showChat = false;
  public connectionState: boolean;

  @ViewChild(PerfectScrollbarComponent) componentRef?: PerfectScrollbarComponent;
  @ViewChild('basicModal') basicModal?: ModalDirective;
  public chatWindows;

  private token: string;
  private adminToken: string;
  private user: UserAuth;
  private notificationInterval: any;
  private originalTitle: string;
  private notificationTitle: string;
  public citizenName: string;
  public formalityName: string;
  public test = true;

  constructor(private toastMsg: ToastService,
              private eb: EventBusService,
              private chatRequestResource: ChatRequestResource,
              private titleService: Title,
              private authProv: AuthServerProvider) {
  }

  ngOnInit() {
    this.originalTitle = this.titleService.getTitle();
    this.notificationTitle = 'Hay una nueva solicitud de chat';
    this.eb.registerHandler('ms.messages.new.chat', (error, message) => {
      console.log('Habemus chat');
      if (error) {
        console.error('AppEventBusService.handleAction error', error);
        return;
      }
      if (!message.body) {
        console.error('AppEventBusService.handleAction - body is required in message', message);
        return;
      }
      this.token = message.body.token;
      if (message.body.request) {
        this.citizenName = message.body.request.name;
        if (message.body.request.formalityName && message.body.request.formalityName.trim() != '')
          this.formalityName = message.body.request.formalityName;
      }
      console.log('Token: ' + this.token);
      this.basicModal.show();
      this.newChatNotification();
      console.log(message);
      console.log(error);
    });
    this.connectionState = this.eb.connected;
    this.user = this.authProv.getUserDecoded();
    window.addEventListener('beforeunload', ev => this.beforeunloadHandler(ev));
  }

  ngOnDestroy(): void {
    console.log('Se destruirán todas las conversaciones');
    console.log(this.chatList);
    this.chatList.forEach(chat => {
      this.cleanMessages(chat.token, chat.adminToken, <MessageModel>{error: ''});
    });
  }

  @HostListener('window:beforeunload', ['$event'])
  beforeunloadHandler(event) {
    console.log('Se destruirán todas las conversaciones');
    console.log(this.chatList);
    this.chatList.forEach(chat => {
      this.cleanMessages(chat.token, chat.adminToken, <MessageModel>{error: ''});
    });
    if (window.confirm('¿Está seguro que desea salir?')) {
      this.chatList.forEach(chat => {
        this.cleanMessages(chat.token, chat.adminToken, <MessageModel>{error: ''});
      });
    } else {
      console.log('Se rechazó');
    }
    return false;
  }

  saveMessage(token: string, adminToken, message: MessageModel) {
    if ((!message.message || message.message.trim() === '') && (!message.error || message.error.trim() === ''))
      return;
    message.created_at = new Date();
    console.log('Token por default: ' + this.token);
    message.token = token ? token : this.token;
    console.log('Token final ' + message.token);
    message.adminToken = adminToken;
    message.user_id = this.user._id;
    this.chatRequestResource.sendMessage(message).then(aVoid => {
      if (message.error)
        message.error = null;
    }, err => {
      console.log(err);
    });
    setTimeout(() => {
      message.message = '';
      this.scrollMessages();
    }, 200);
  }

  scrollMessages() {
    setTimeout(ar => {
      if (this.componentRef)
        this.componentRef.directiveRef.scrollToBottom();
    }, 100);
  }

  acceptRequest() {
    this.chatRequestResource.acceptRequest(<MessageModel>{token: this.token}).then(message => {
      this.adminToken = message.adminToken;
      this.basicModal.hide();
      this.formalityName = null;
      this.createConversation(this.token, this.citizenName);
      this.saveMessage(this.token, this.adminToken, <MessageModel>{message: 'Hola, buen día. ¿En que podemos ayudarle?'});
      this.showChat = true;
    }, err => {
      this.toastMsg.error('Error al aceptar la petición');
      console.log(err);
    });
  }

  createConversation(token, citizenName: string) {
    const address = 'ms.messages.chat.' + token;
    console.log('Intentando conexión con: ' + address);
    this.eb.registerHandler(address, (error, message) => {
      if (error) {
        console.error('AppEventBusService.handleAction error', error);
        return;
      }
      if (!message.body) {
        console.error('AppEventBusService.handleAction - body is required in message', message);
        return;
      }
      const chatTemp = this.chatList.find(chat => chat.token === message.body.token);
      if (!chatTemp || chatTemp.adminToken === message.body.adminToken) {
        // Si viene un mensaje de error se agrega al mensaje principal
        if (message.body.error && message.body.error !== '') {
          message.body.message = message.body.error;
        }
        console.log('Mensaje recibido');
        console.log(message);
        let chatExists = false;
        this.chatList.forEach(chat => {
          if (chat.token === token) {
            chatExists = true;
            chat.messages.push(message.body);
          }
        });
        // Si no existe la ventana de chat con el usuario la crea
        if (!chatExists) {
          const newChat
            = {token: message.body.token, messages: [message.body], adminToken: message.body.adminToken, citizenName: citizenName};
          this.chatList.push(newChat);
          this.message.push(<MessageModel>{});
          setTimeout(() => {
            this.chatWindows.show();
            // this.chatWindows._el.nativeElement.className = 'collapse chat-height show';
            // this.chatWindows._el.nativeElement.style.setProperty('height', '389px');
            this.chatWindows.isExpanded = true;
          });
        }
        this.scrollMessages();
      }
    });
  }

  cleanMessages(token: string, adminToken: string, message: MessageModel) {
    console.log('Limpiar Mensajes: ' + token + ':' + adminToken);
    console.log(message);
    message.error = 'El funcionario ha dejado la conversación';
    console.log('Dejaremos la conversación');
    console.log(message);
    this.saveMessage(token, adminToken, message);
    this.eb.unregister('ms.messages.chat.' + token);
    this.chatList.splice(this.chatList.indexOf(this.chatList.find(chat => chat.token === token)), 1);
  }

  newChatNotification() {
    this.stopInterval();
    const audio = new Audio();
    audio.src = '../../../assets/audio/notification_sound.mp3';
    audio.load();
    audio.play();
    this.notificationInterval = setInterval(() => {
      if (this.titleService.getTitle() === this.originalTitle) {
        this.titleService.setTitle(this.notificationTitle);
      } else {
        this.titleService.setTitle(this.originalTitle);
      }
    }, 1000);
  }

  stopInterval() {
    if (this.notificationInterval) {
      clearInterval(this.notificationInterval);
      this.notificationInterval = null;
      this.titleService.setTitle(this.originalTitle);
      this.test = !this.test;
      console.log('Se activó el stopInterval');
    }
  }

  setSelectedChat(event) {
    this.chatWindows = event;
  }
}
